export default "__VITE_ASSET__BLTKE_mu__"